"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuItem = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _ButtonBase = require("../ButtonBase");

var _styleHelpers = require("../styleHelpers");

var _Typography = require("../Typography");

var _useCustomStyles = require("../utils/useCustomStyles");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var MenuItemBox = _styledComponents.default.div.withConfig({
  displayName: "MenuItem__MenuItemBox",
  componentId: "qzoubs-0"
})(["", " display:block;color:", ";text-decoration:none;margin-top:", ";margin-bottom:", ";padding:", ";", " ", ""], _ButtonBase.buttonBaseStyles, (0, _styleHelpers.getColor)('common', 'black'), (0, _styleHelpers.getSpacing)(1), (0, _styleHelpers.getSpacing)(1), (0, _styleHelpers.getSpacing)(2), function (props) {
  return props.selected ? (0, _styledComponents.css)(["background-color:", ";"], (0, _styleHelpers.getColor)('brand', 'lightest')) : (0, _styledComponents.css)(["&:hover{background-color:", ";}&:active{background-color:", ";}"], (0, _styleHelpers.getColor)('gray', '50'), (0, _styleHelpers.getColor)('gray', '100'));
}, (0, _useCustomStyles.getCustomStyles)('menu.styles', 'item'));

var MenuItem = function MenuItem(_ref) {
  var children = _ref.children,
      onClick = _ref.onClick,
      as = _ref.as,
      customStyles = _ref.customStyles,
      props = _objectWithoutProperties(_ref, ["children", "onClick", "as", "customStyles"]);

  return /*#__PURE__*/_react.default.createElement(MenuItemBox, _extends({
    "data-testid": "pbl-menu-item",
    as: as,
    onClick: onClick,
    customStyles: customStyles
  }, props), /*#__PURE__*/_react.default.createElement(_Typography.ButtonTypography, {
    customStyles: {
      button: (0, _useCustomStyles.useCustomStyles)('menu.styles', customStyles)('itemText')
    }
  }, children));
};

exports.MenuItem = MenuItem;